export const enum direction {"left", "up", "right", "down", "none"};

export const enum gameState {"start", "end", "pause", "play", "load"};

export const enemyType = Object.freeze({"sedan": 0, "hatchback": 1, "fuel_truck": 2, "ambulance": 3, "buggy": 4, "battle_truck": 5, "tank": 6});

export const lootType = Object.freeze({"health": 0, "coin_flip": 1, "shield": 2, "magnet": 3, "split_shooter": 4,  "laser": 5, "turret": 6});

export const powerUpType = Object.freeze({"shield": 0, "magnet": 1, "split_shooter": 2,  "laser": 3, "turret": 4});

export const enum bulletType {"player", "buggy", "battle_truck", "tank", "split_shooter", "laser"};
